export type ResponseTone = 'neutral' | 'warning' | 'danger';
export interface ResponseThreshold {
  afterMs: number;
  tone: ResponseTone;
  label: string;
}
export interface ResponseWait {
  since: string;
  /** Service-owned policy. No implicit deadlines or business rules. */
  thresholds?: readonly ResponseThreshold[];
}
export function responseAge(since: string, now: number): number | null {
  const start = Date.parse(since);
  return Number.isFinite(now) && Number.isFinite(start) && start <= now ? now - start : null;
}
export function formatResponseAge(age: number | null): string {
  if (age === null || !Number.isFinite(age) || age < 0) return 'Неизвестно';
  const minutes = Math.floor(age / 60_000);
  if (!minutes) return '< 1 мин';
  if (minutes < 60) return minutes + ' мин';
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return hours + ' ч ' + String(minutes % 60).padStart(2, '0') + ' мин';
  return Math.floor(hours / 24) + ' д ' + String(hours % 24).padStart(2, '0') + ' ч';
}
export function responseState(wait: ResponseWait, now: number) {
  const age = responseAge(wait.since, now);
  let threshold: ResponseThreshold | undefined;
  if (age !== null) {
    for (const item of wait.thresholds ?? []) {
      if (
        Number.isFinite(item.afterMs) &&
        item.afterMs >= 0 &&
        item.afterMs <= age &&
        (!threshold || item.afterMs >= threshold.afterMs)
      )
        threshold = item;
    }
  }
  return { age, value: formatResponseAge(age), tone: threshold?.tone ?? 'neutral', label: threshold?.label };
}
